import React from "react";

const headerHome = () => {


  return (
    <>
     <div className="topnav" id="myTopnav">
  <a href="/" className="active">Inicio</a>
  <a href="game">Jugar</a>
  <a href="#contact">Contacto</a>
  <a href="#about">Conoce más</a>
    <i class="fa fa-bars"></i></div>
  
  {/* <button class="tablink" onclick="openPage('Home', this, 'red')">Inicio</button>
<button class="tablink" onclick="openPage('News', this, 'green')" id="defaultOpen">Jugar</button>
<button class="tablink" onclick="openPage('Contact', this, 'blue')">Contacto</button>
<button class="tablink" onclick="openPage('About', this, 'orange')">Conoce más</button> */}



      {/* <Header /> */}
      {/* <Main /> */}
      {/* <Footer /> */}
    </>
  );
};

export default headerHome;